export default "__VITE_ASSET__J_e3HbsJ__"